<template>
  <v-flex class="pdf-container fill-height">
    <!-- Spinner -->
    <DefaultLoading v-if="loading" :loading="loading" />

    <!-- Error -->
    <div v-if="error" class="pdf-error">
      <v-alert type="error" dense>
        {{ $t("document_error") }}
      </v-alert>
    </div>

    <!-- Viewer -->
    <div v-if="!loading && !error" class="pdf-wrapper">
      <iframe
        ref="pdfViewer"
        :src="viewerUrl + '#page=1&scrollMode=0'"
        frameborder="0"
        class="pdf-iframe"
        @load="onIframeLoaded"
      />
    </div>
  </v-flex>
</template>

<script>
import DefaultLoading from "./DefaultLoading.component";
import { SignaturesService } from "../../services/signatures-service";

export default {
  name: "PdfViewer",
  components: { DefaultLoading },
  data() {
    return {
      loading: false,
      error: false,
      blobUrl: null,
      requestId: localStorage.getItem("request_id"),
      authId: localStorage.getItem("auth_id"),
      transactionId: localStorage.getItem("transaction_id"),
      fileName: localStorage.getItem("file_name"),
      iframeReady: false,
      iframeWindow: null,
    };
  },
  computed: {
    viewerUrl() {
      if (!this.blobUrl) return "";
      // Ajusta la ruta si colocaste los archivos en otra carpeta
      return `/pdfjs/web/custom-viewer.html?file=${encodeURIComponent(this.blobUrl)}#page=1&zoom=page-fit&scrollMode=2`;
    },
  },
  mounted() {
    // console.log(localStorage.getItem("request_id"));
    // console.log(localStorage.getItem("transaction_id"));
    // console.log(localStorage.getItem("auth_id"));
    // console.log(localStorage.getItem("file_name"));

    this.transactionId = localStorage.getItem("transaction_id");
    this.requestId = localStorage.getItem("request_id");
    this.authId = localStorage.getItem("auth_id");

    this.fileName = localStorage.getItem("file_name");
    console.log("Transaction ID en mounted:", this.transactionId);
    console.log("Request ID en mounted:", this.requestId);
    console.log("Auth ID en mounted:", this.authId);
    console.log("File Name: ", this.fileName);

    this.loadDocument();
  },
  methods: {
    // MÉTODO PÚBLICO que llamará el padre:
        getPageInfo() {
          if (!this.iframeWindow || typeof this.iframeWindow.getVisiblePageAndScale !== "function") {
            throw new Error("No pude leer página/escala del iframe");
          }
          return this.iframeWindow.getVisiblePageAndScale();
        },

    async onIframeLoaded() {
      console.log("✅ PDF.js viewer cargado en iframe");
      this.iframeReady = true;
      this.$emit("loaded");

      // ————————— Paso 2: inyectar CSS para controlar los scrolls dentro del iframe —————————
      try {
        const iframe = this.$refs.pdfViewer;
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        const head = doc.head || doc.getElementsByTagName('head')[0];

        const style = doc.createElement('style');
        style.type = 'text/css';
        style.innerHTML = `
          /* 1) Oculta cualquier scrollbar de html/body dentro del iframe */
          html, body {
            overflow: hidden !important;
            margin: 0;
            padding: 0;
            height: 100% !important;
          }
          /* 2) Sólo #viewerContainer (el contenedor de páginas) hará scroll */
          #viewerContainer {
            overflow: auto !important;
            height: 100% !important;
          }
          /* 3) Opcional: oculta scrollbars de WebKit en html/body */
          html::-webkit-scrollbar,
          body::-webkit-scrollbar {
            display: none;
          }
        `;
        head.appendChild(style);
        console.log("🔧 CSS de scroll inyectado en el iframe");
      } catch (e) {
        console.warn("⚠️ Error inyectando CSS en el iframe:", e);
      }

      // ———————— Resto de tu lógica original ————————
      try {
        const win = this.$refs.pdfViewer.contentWindow;

        // Escuchamos cuando PDF.js emita que terminó de arrancar
        win.document.addEventListener("viewerloaded", () => {
          console.log("[PDFJSViewer] El visor ya terminó de arrancar");
          this.$emit("loaded");  // dispara tu @loaded en FieldsSignature
        });

        // Recuperamos página y escala
        const info = await win.getVisiblePageAndScale();
        console.log(
          "[PDFJSViewer] Página visible:",
          info.page,
          "Escala:",
          info.scale
        );
        this.$emit("page-scale", info);
      } catch (err) {
        console.error("[PDFJSViewer] No pude recuperar página/escala:", err);
      }
    },


    loadDocument() {
      this.error = false;
      if (!this.requestId) {
        this.error = true;
        return;
      }
      this.loading = true;
      SignaturesService.getSignatureRequestDocument(this.requestId, this.authId)
        .then((response) => {
          // Creamos un Blob y generamos un object URL
          const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
          });
          this.blobUrl = URL.createObjectURL(pdfBlob);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.error("Error cargando PDF:", err);
          this.error = true;
        });
    },
  },
  beforeDestroy() {
    // Revocamos el URL al destruir el componente
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl);
    }
  },
};
</script>

<style scoped>
/* Oculta scroll en toda la página cuando el PDF está dentro */
body.pdf-active {
  overflow: hidden !important;
}

/* El contenedor principal vuélvelo “imposible de scrollear” */
.pdf-container {
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}

/* El wrapper directo tampoco scroll */
.pdf-wrapper {
  position: relative;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}

/* El iframe ocupa todo el espacio, deja el scroll para PDF.js */
.pdf-iframe {
  position: absolute !important;
  top: 0; left: 0;
  width: 100% !important;
  height: 100% !important;
  border: none;
}

.pdf-wrapper {
  position: relative;
  width: 100%;
  /* Ajusta altura si tienes toolbar fijo */
  height: calc(100vh - 64px);
}
.pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.pdf-error {
  padding: 1em;
}
</style>
